import React, { useState, useEffect } from 'react'
import Link from 'next/link'
import { useInView } from 'react-intersection-observer'
import LeadershipModal from './LeadershipModal'
import LazyImage from '../LazyImage'
import ReactModal from 'react-modal'
//Used For Leadership page image cards

function useModalState () {
  const [modalIsOpen, setIsOpen] = useState(false)
  return [
    modalIsOpen,
    setIsOpen,
    item => setIsOpen(!modalIsOpen !== item.ID ? item.ID : false)
  ]
}

export default function ImageCard (props) {
  const [modalValue, setModalValue] = useModalState()
  const [slideUpRef, isInView] = useInView({ triggerOnce: true })
  const { title, body } = props

  const renderCard = items =>
    items.map(item => {
      const image = item.founders_staff_image
      const [slideUpRef, isInView] = useInView({ triggerOnce: true })

      if (props.founders) {
        return (
          //Founders Cards using founders_staff fields
          <React.Fragment key={image.id + item.founders_staff_name}>
            <div
              ref={slideUpRef}
              className={`col-12 col-md-6 col-lg-4 founders__staff animation ${
                isInView ? 'slide-up' : ''
              }`}
            >
              <LazyImage background imageClass='staff__image' src={image.url} />
              <div className='staff__text'>
                <div className='staff__name'>{item.founders_staff_name} </div>
                <div className='staff__title'>{item.founders_staff_title}</div>

                {item.founders_staff_page_link ? (
                  <Link href={item.founders_staff_page_link} passHref>
                    <a className='link'>
                      View{' '}
                      <span className='sr-only'>
                        {item.founders_staff_name}'s
                      </span>{' '}
                      Bio
                    </a>
                  </Link>
                ) : (
                  ''
                )}
              </div>
            </div>
          </React.Fragment>
        )
      } if (props.directors) {
        return (
        //Board Members Cards using directors acf fields
          <React.Fragment key={item.director_name + item.director_title}>
          <div
            ref={slideUpRef}
            className={`col-12 col-md-6 col-lg-4 justify-content-between animation ${
              isInView ? 'slide-up' : ''
            }`}
          >
            <div className='director'>
              <button
                onClick={() => setModalValue(item)}
                className='director-bio-link'
              >
                <LazyImage
                  background
                  imageClass='director__image'
                  src={item.director_image}
                />

                <div className='director-viewbio d-flex align-items-center justify-content-center'>
                  <div className='link'>
                    View <span className='sr-only'>{item.director_name}'s</span>{' '}
                    Bio
                  </div>
                </div>
              </button>
              <h3 className='director__name'>{item.director_name} </h3>
              <h2 className='director__title'>{item.director_title}</h2>
            </div>
          </div>
        </React.Fragment>
        )
      } if (props.advisers) {
        return (
          <React.Fragment key={item.adviser_name + item.adviser_title}>
          <div
            ref={slideUpRef}
            className={`col-12 col-md-6 col-lg-4 justify-content-between animation ${
              isInView ? 'slide-up' : ''
            }`}
          >
            <div className='director'>
              { item.adviser_image ? (
                <LazyImage
                  background
                  imageClass='director__image'
                  src={item.adviser_image.url}
                />
              ) : (
                ''
              )}
              <h3 className='director__name'>{item.adviser_name} </h3>
              <h2 className='director__title'>{item.adviser_title}</h2>
            </div>
          </div>
        </React.Fragment>
        )

      } if (props.juniorAdvisers) {
        return (
          <React.Fragment key={item.adviser_name + item.adviser_title}>
            <div
              ref={slideUpRef}
              className={`col-12 col-md-6 col-lg-4 justify-content-between animation ${
                isInView ? 'slide-up' : ''
              }`}
            >
              <div className='director'>
                { item.adviser_image ? (
                  <LazyImage
                    background
                    imageClass='director__image'
                    src={item.adviser_image.url}
                  />
                ) : (
                  ''
                )}
                <h3 className='director__name'>{item.adviser_name} </h3>
                <h2 className='director__title'>{item.adviser_title}</h2>
              </div>
            </div>
          </React.Fragment>
        )
      }
      else {
      }
    
      
         
    })

  const renderModal = item => (
    <React.Fragment>
      <div
        key={'modal' + item.director_name + item.director_title}
        className='biomodal-content'
      >
        <h2>{item.director_name}</h2>
        <h3>{item.director_title}</h3>
        <div dangerouslySetInnerHTML={{ __html: item.director_bio }} />
      </div>
    </React.Fragment>
  )

  return (
    <React.Fragment>
      <div
        className={`container-fluid  ${
          props.founders ? 'founders' : 'board-directors'
        } `}
      >
        {!props.founders ? (
          <div className='row'>
            <div
              ref={slideUpRef}
              className={`col-10 offset-1 animation ${
                isInView ? 'slide-up' : ''
              }`}
            >
              <h2
                className='heading2'
                dangerouslySetInnerHTML={{ __html: title }}
              />
            </div>
          </div>
        ) : (
          ''
        )}

        <div className='slide-up row justify-content-center'>
          {props.founders ? (
            <div
              ref={slideUpRef}
              className={`col-10 text-center founders__text align-self-center animation ${
                isInView ? 'slide-up' : ''
              }`}
            >
              <h2
                className='heading2'
                dangerouslySetInnerHTML={{ __html: title }}
              />
              <div dangerouslySetInnerHTML={{ __html: body }} />
            </div>
          ) : (
            ''
          )}

          <div className='col-12 col-lg-10'>
            <div className='row'>{renderCard(props.content)}</div>
          </div>
        </div>
      </div>

      {props.modal ? (
        <LeadershipModal isOpen={!!modalValue} shouldCloseOverlayClick={true}>
          {renderModal(modalValue)}

          <button
            onClick={() => setModalValue(false)}
            className='biomodal_close'
          >
            <img
              src='/public-next/images/closebiomodal.svg'
              width='21'
              height='21'
              alt='close'
            />
          </button>
        </LeadershipModal>
      ) : (
        ''
      )}

      <style jsx>{`
        .founders,
        .board-directors {
          margin-bottom: 200px !important;
        }
      `}</style>
    </React.Fragment>
  )
}
